import { defineStore } from 'pinia'

export const useTextFilterStore = defineStore('TextFilterStore', {
  state: () => {
    return {
      filter: null,
    }
  },
  getters: {
    asObject: (state) => {
      if (!state.filter || state.filter === '') {
        return { q: null }
      }

      return { q: state.filter }
    },
  },
  actions: {
    fromQueryParams({ q }) {
      this.filter = q
    },
    toQueryParams() {
      if (!this.filter || this.filter === '') {
        return { q: null }
      }

      return {
        q: this.filter,
      }
    },
  },
})
